import { Injectable, Directive, Inject, ElementRef, Input, Component, ViewEncapsulation, Host, HostListener, forwardRef, NgModule } from '@angular/core';
import { DOCUMENT, CommonModule } from '@angular/common';
import { PageScrollService, NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { NgModel, Validators, NG_VALIDATORS } from '@angular/forms';
import { range } from 'linq/linq';
import { isNullOrUndefined } from 'util';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/service/auto-validate.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AutoValidateService {
    constructor() {
        this.errors = new Map();
    }
    /**
     * @param {?} formKey
     * @param {?} controlKey
     * @param {?} message
     * @return {?}
     */
    set(formKey, controlKey, message) {
        /** @type {?} */
        const formMap = this.errors.get(formKey);
        if (formMap) {
            formMap.set(controlKey, message);
        }
        else {
            /** @type {?} */
            const controlMap = new Map();
            controlMap.set(controlKey, message);
            this.errors.set(formKey, controlMap);
        }
    }
    /**
     * @param {?} formKey
     * @param {?} controlKey
     * @return {?}
     */
    get(formKey, controlKey) {
        /** @type {?} */
        const formMap = this.errors.get(formKey);
        if (!formMap) {
            return null;
        }
        return formMap.get(controlKey);
    }
    /**
     * @param {?} formKey
     * @param {?=} controlKey
     * @return {?}
     */
    delete(formKey, controlKey) {
        if (controlKey) {
            /** @type {?} */
            const formMap = this.errors.get(formKey);
            if (formMap) {
                formMap.delete(controlKey);
            }
        }
        else {
            this.errors.delete(formKey);
        }
    }
}
AutoValidateService.decorators = [
    { type: Injectable }
];
/** @nocollapse */
AutoValidateService.ctorParameters = () => [];
if (false) {
    /** @type {?} */
    AutoValidateService.prototype.errors;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/auto-validate-form.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: techmore-auto-validate-form
 */
class AutoValidateFormDirective {
    /**
     * @param {?} pageScrollService
     * @param {?} document
     * @param {?} elRef
     */
    constructor(pageScrollService, document, elRef) {
        this.pageScrollService = pageScrollService;
        this.document = document;
        this.elRef = elRef;
        this.validators = new Set();
        this.hasError = false;
        this.el = this.elRef.nativeElement;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.name === '') {
            throw new Error('沒有設定techmore-auto-validate-form key');
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewChecked() {
        if (this.hasError) {
            /** @type {?} */
            const controlName = this.firstErrorValidator.controlName;
            /** @type {?} */
            const controlEl = this.firstErrorValidator.el;
            /** @type {?} */
            let pageScrollOption = this.scrollingViews ?
                {
                    document: this.document,
                    scrollTarget: controlEl,
                    scrollOffset: 100,
                    scrollViews: [(typeof this.scrollingViews === 'string' ? this.document.querySelector(this.scrollingViews) : this.scrollingViews)]
                } : {
                document: this.document,
                scrollTarget: controlEl,
                scrollOffset: 100,
            };
            this.pageScrollService.scroll(pageScrollOption);
            controlEl.focus();
            delete this.firstErrorValidator;
            this.hasError = false;
        }
    }
    /**
     * @return {?}
     */
    validateAll() {
        delete this.firstErrorValidator;
        this.validators.forEach((/**
         * @param {?} value
         * @param {?} index
         * @param {?} set
         * @return {?}
         */
        (value, index, set) => {
            if (!value.validate() && !this.firstErrorValidator) {
                this.firstErrorValidator = value;
            }
        }));
        if (this.firstErrorValidator) {
            this.hasError = true;
        }
    }
}
AutoValidateFormDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmAutoValidateForm]',
                providers: [AutoValidateService],
                exportAs: 'tmAutoValidateForm'
            },] }
];
/** @nocollapse */
AutoValidateFormDirective.ctorParameters = () => [
    { type: PageScrollService },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: ElementRef }
];
AutoValidateFormDirective.propDecorators = {
    name: [{ type: Input, args: ['tmAutoValidateForm',] }],
    scrollingViews: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    AutoValidateFormDirective.prototype.name;
    /**
     * 滾動容器的元素獲選取子
     * @type {?}
     */
    AutoValidateFormDirective.prototype.scrollingViews;
    /** @type {?} */
    AutoValidateFormDirective.prototype.el;
    /** @type {?} */
    AutoValidateFormDirective.prototype.validators;
    /**
     * @type {?}
     * @protected
     */
    AutoValidateFormDirective.prototype.hasError;
    /**
     * @type {?}
     * @protected
     */
    AutoValidateFormDirective.prototype.firstErrorValidator;
    /**
     * @type {?}
     * @protected
     */
    AutoValidateFormDirective.prototype.pageScrollService;
    /**
     * @type {?}
     * @protected
     */
    AutoValidateFormDirective.prototype.document;
    /**
     * @type {?}
     * @protected
     */
    AutoValidateFormDirective.prototype.elRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/component/validation-error/validation-error.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: techmore-validation-error
 */
class ValidationErrorComponent {
    /**
     * @param {?} form
     * @param {?} autoValidateService
     */
    constructor(form, autoValidateService) {
        this.form = form;
        this.autoValidateService = autoValidateService;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.form.name === '') {
            throw new Error('沒有設定techmore-auto-validate-form key');
        }
        this.formName = this.form.name;
    }
    /**
     * @return {?}
     */
    ngDoCheck() {
        this.errorMessage = this.autoValidateService.get(this.formName, this.controlKey);
    }
}
ValidationErrorComponent.decorators = [
    { type: Component, args: [{
                selector: 'tm-validation-error',
                template: "<div techmore-validation class=\"alert alert-danger\" *ngIf=\"errorMessage && errorMessage != ''\" aria-live=\"assertive\" role=\"alert\">\r\n  {{controlLabel || ''}}{{errorMessage}}\r\n</div>\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [""]
            }] }
];
/** @nocollapse */
ValidationErrorComponent.ctorParameters = () => [
    { type: AutoValidateFormDirective },
    { type: AutoValidateService }
];
ValidationErrorComponent.propDecorators = {
    controlKey: [{ type: Input }],
    controlLabel: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ValidationErrorComponent.prototype.controlKey;
    /** @type {?} */
    ValidationErrorComponent.prototype.controlLabel;
    /** @type {?} */
    ValidationErrorComponent.prototype.formName;
    /** @type {?} */
    ValidationErrorComponent.prototype.errorMessage;
    /**
     * @type {?}
     * @private
     */
    ValidationErrorComponent.prototype.form;
    /**
     * @type {?}
     * @private
     */
    ValidationErrorComponent.prototype.autoValidateService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/entity/validation-error-message.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ValidationErrorMessage {
}
/** @type {?} */
const defalutValidationErrorMessage = {
    required: '這個欄位不可以空白',
    maxlength: '超出字數',
    email: 'email格式不正確',
    tmPhone: '電話格式不正確',
    tmRequireSome: '請最少選擇一項',
    tmRequireSomeMaxLen: '至多不可以超過一項',
    tmValidateEqual: '不一致',
    tmGcbPassword: '未符合密碼規則',
    tmRange: '超過範圍限制',
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/auto-validate.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 表單控件驗證
 * 原名: techmore-auto-validate
 */
class AutoValidateDirective {
    /**
     * @param {?} autoValidateService
     * @param {?} ngModel
     * @param {?} form
     * @param {?} elRef
     */
    constructor(autoValidateService, ngModel, form, elRef) {
        this.autoValidateService = autoValidateService;
        this.ngModel = ngModel;
        this.form = form;
        this.elRef = elRef;
        this._validationErrorMessage = defalutValidationErrorMessage;
        this.el = this.elRef.nativeElement;
    }
    /**
     * @param {?} eMsg
     * @return {?}
     */
    set validationErrorMessage(eMsg) {
        this._validationErrorMessage = Object.assign(JSON.parse(JSON.stringify(this._validationErrorMessage)), eMsg);
    }
    /**
     * @return {?}
     */
    get validationErrorMessage() {
        return this._validationErrorMessage;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        if (this.form.name === '') {
            // tslint:disable-next-line:no-string-throw
            throw new Error('沒有設定techmore-auto-validate-form');
        }
        this.form.validators.add(this);
        this.formName = this.form.name;
        if (this.controlName === '') {
            this.controlName = this.ngModel.name;
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.autoValidateService.delete(this.formName, this.controlName);
        this.form.validators.delete(this);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onChange($event) {
        this.validate();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onInput($event) {
        this.validate();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    onBlur($event) {
        this.validate();
    }
    /**
     * @return {?}
     */
    validate() {
        /** @type {?} */
        let errorMessage = '';
        if (this.ngModel.invalid) {
            // tslint:disable-next-line:forin
            for (const key in this.ngModel.errors) {
                if (this.validationErrorMessage[key]) {
                    errorMessage += this.validationErrorMessage[key] + ' ';
                }
                else {
                    errorMessage += this.ngModel.errors[key] + '';
                }
            }
        }
        this.ngModel.control.markAsTouched();
        this.autoValidateService.set(this.formName, this.controlName, errorMessage);
        return this.ngModel.valid;
    }
}
AutoValidateDirective.decorators = [
    { type: Directive, args: [{
                selector: '[ngModel][tmAutoValidate]',
                exportAs: 'tmAutoValidate'
            },] }
];
/** @nocollapse */
AutoValidateDirective.ctorParameters = () => [
    { type: AutoValidateService },
    { type: NgModel, decorators: [{ type: Host }] },
    { type: AutoValidateFormDirective },
    { type: ElementRef }
];
AutoValidateDirective.propDecorators = {
    controlName: [{ type: Input, args: ['tmAutoValidate',] }],
    validationErrorMessage: [{ type: Input }],
    onChange: [{ type: HostListener, args: ['change', ['$event'],] }],
    onInput: [{ type: HostListener, args: ['input', ['$event'],] }],
    onBlur: [{ type: HostListener, args: ['blur', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    AutoValidateDirective.prototype.formName;
    /** @type {?} */
    AutoValidateDirective.prototype.controlName;
    /** @type {?} */
    AutoValidateDirective.prototype._validationErrorMessage;
    /** @type {?} */
    AutoValidateDirective.prototype.el;
    /**
     * @type {?}
     * @private
     */
    AutoValidateDirective.prototype.autoValidateService;
    /**
     * @type {?}
     * @private
     */
    AutoValidateDirective.prototype.ngModel;
    /**
     * @type {?}
     * @private
     */
    AutoValidateDirective.prototype.form;
    /**
     * @type {?}
     * @protected
     */
    AutoValidateDirective.prototype.elRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/validation/default.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class DefaultValidatorAbs {
    /**
     * @param {?} control
     * @return {?}
     */
    validate(control) {
        if (isNullOrUndefined(control.value) || control.value === '') {
            return Validators.nullValidator;
        }
        else {
            /** @type {?} */
            const name = control.value;
            return this.valid(name) ? null : { [this.tagName]: { name } };
        }
    }
    /**
     * @return {?}
     */
    get tagName() {
        return this._tagName;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set tagName(value) {
        this._tagName = value;
    }
}
if (false) {
    /**
     * @type {?}
     * @protected
     */
    DefaultValidatorAbs.prototype._tagName;
    /**
     * @abstract
     * @param {?} val
     * @return {?}
     */
    DefaultValidatorAbs.prototype.valid = function (val) { };
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/validation/taiwan-id.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: taiwan-id
 */
class TaiwanIdDirective extends DefaultValidatorAbs {
    constructor() {
        super(...arguments);
        this._tagName = 'tmTaiwanId';
        this.city = [1, 10, 19, 28, 37, 46, 55, 64, 39, 73, 82, 2, 11, 20, 48, 29, 38, 47, 56, 65, 74, 83, 21, 3, 12, 30];
    }
    /**
     * @param {?} val
     * @return {?}
     */
    valid(val) {
        return this.checkTwID(val);
    }
    /**
     * @param {?} id
     * @return {?}
     */
    checkTwID(id) {
        id = id.toUpperCase();
        // 使用「正規表達式」檢驗格式
        if (id.search(/^[A-Z](1|2)\d{8}$/i) == -1) {
            return false;
        }
        else {
            // 計算檢查碼
            /** @type {?} */
            let checksum = this.city[id.charCodeAt(0) - 65];
            range(1, 8, 1).forEach((/**
             * @param {?} point
             * @return {?}
             */
            point => {
                checksum += eval(id.charAt(point)) * (9 - point);
            }));
            checksum += eval(id.charAt(9));
            return checksum % 10 === 0;
        }
    }
}
TaiwanIdDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmTaiwanId]',
                providers: [{ provide: NG_VALIDATORS, useExisting: TaiwanIdDirective, multi: true }]
            },] }
];
if (false) {
    /**
     * @type {?}
     * @protected
     */
    TaiwanIdDirective.prototype._tagName;
    /** @type {?} */
    TaiwanIdDirective.prototype.city;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/validation/phone.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: phone
 * 台灣電話號碼格式
 * https://zh.wikipedia.org/wiki/%E4%B8%AD%E8%8F%AF%E6%B0%91%E5%9C%8B%E9%95%B7%E9%80%94%E9%9B%BB%E8%A9%B1%E5%8D%80%E8%99%9F%E8%A1%A8
 */
class PhoneDirective extends DefaultValidatorAbs {
    constructor() {
        super();
        this._tagName = 'tmPhone';
        this._allowDashFormat = true;
        this._allowSimpleFormat = true;
        this._allowParenthesesFormat = true;
        this._allowSmartPhoneFormat = true;
    }
    /**
     * 只允許手機號碼，真值則不可輸入市話號碼，否則全部開放
     * @param {?} isOnlySmartPhone
     * @return {?}
     */
    set onlySmartPhoneFormat(isOnlySmartPhone) {
        if (isOnlySmartPhone && this._onlyCityPhoneFormat) {
            throw new Error('can\'t use onlyCityPhoneFormat and onlySmartPhoneFormat together, ther\re conflict');
        }
        this._onlySmartPhoneFormat = isOnlySmartPhone;
        if (isOnlySmartPhone) {
            this._onlyCityPhoneFormat = false;
        }
    }
    /**
     * 只允許市話號碼，真值則不可輸入手機號碼，否則全部開放
     * @param {?} isOnlyCityPhone
     * @return {?}
     */
    set onlyCityPhoneFormat(isOnlyCityPhone) {
        if (isOnlyCityPhone && this._onlySmartPhoneFormat) {
            throw new Error('can\'t use onlyCityPhoneFormat and onlySmartPhoneFormat together, ther\re conflict');
        }
        this._onlyCityPhoneFormat = isOnlyCityPhone;
        if (isOnlyCityPhone) {
            this._onlySmartPhoneFormat = false;
        }
    }
    /**
     * 整合最後的電話格式
     * @return {?}
     */
    unifyFormat() {
        if (this._onlySmartPhoneFormat) {
            this._allowDashFormat = false;
            this._allowParenthesesFormat = false;
            this._allowSimpleFormat = false;
            this._allowSmartPhoneFormat = true;
        }
        else if (this._onlyCityPhoneFormat) {
            this._allowDashFormat = true;
            this._allowParenthesesFormat = true;
            this._allowSimpleFormat = true;
            this._allowSmartPhoneFormat = false;
        }
        if (!isNullOrUndefined(this.allowDashFormat)) {
            this._allowDashFormat = this.allowDashFormat;
        }
        if (!isNullOrUndefined(this.allowParenthesesFormat)) {
            this._allowParenthesesFormat = this.allowDashFormat;
        }
        if (!isNullOrUndefined(this.allowSimpleFormat)) {
            this._allowSimpleFormat = this.allowDashFormat;
        }
        if (!isNullOrUndefined(this.allowSmartPhoneFormat)) {
            this._allowSmartPhoneFormat = this.allowDashFormat;
        }
    }
    /**
     * @param {?} val
     * @return {?}
     */
    valid(val) {
        this.unifyFormat();
        /** @type {?} */
        let hasMatch = false;
        if (this._allowDashFormat) {
            /** @type {?} */
            const tele_phone1_1 = /^0[345678]{1}-\d{7}\b/;
            // ex: 01-1234567 1+7
            /** @type {?} */
            const tele_phone1_2 = /^0[24]-\d{8}\b/;
            // ex: 02-12345678 台北02、台中04 1+8
            /** @type {?} */
            const tele_phone1_3 = /^0\d{2}-\d{6}\b/;
            // ex: 012-123456 苗栗、台東、金門 2+6
            /** @type {?} */
            const tele_phone1_4 = /^049-\d{7}\b/;
            // ex: 049-1234567 南投 2+7
            /** @type {?} */
            const tele_phone1_5 = /^0\d{3}-\d{5}\b/;
            hasMatch = tele_phone1_1.test(val)
                || tele_phone1_2.test(val)
                || tele_phone1_3.test(val)
                || tele_phone1_4.test(val)
                || tele_phone1_5.test(val);
            if (hasMatch) {
                return true;
            }
        }
        if (this._allowParenthesesFormat) {
            /** @type {?} */
            const tele_phone3_1 = /^\((0[345678]{1})\)\d{7}\b/;
            // ex: (01)1234567
            /** @type {?} */
            const tele_phone3_2 = /^\((0[24])\)\d{8}\b/;
            // ex: (02)12345678
            /** @type {?} */
            const tele_phone3_3 = /^\((0\d{2})\)\d{6}\b/;
            // ex: (035)123456
            /** @type {?} */
            const tele_phone3_4 = /^\((049)\)\d{7}\b/;
            // ex: (049)1234567
            /** @type {?} */
            const tele_phone3_5 = /^\((0\d{3})\)\d{5}\b/;
            hasMatch = tele_phone3_1.test(val)
                || tele_phone3_2.test(val)
                || tele_phone3_3.test(val)
                || tele_phone3_4.test(val)
                || tele_phone3_5.test(val);
            if (hasMatch) {
                return true;
            }
        }
        if (this._allowSimpleFormat) {
            /** @type {?} */
            const tele_phone2_1 = /^0[345678]{1}\d{7}\b/;
            // ex: 011234567
            /** @type {?} */
            const tele_phone2_2 = /^0[24]{1}\d{8}\b/;
            // ex: 0212345678
            /** @type {?} */
            const tele_phone2_3 = /^049\d{7}\b/;
            hasMatch = tele_phone2_1.test(val)
                || tele_phone2_2.test(val)
                || tele_phone2_3.test(val);
            if (hasMatch) {
                return true;
            }
        }
        if (this._allowSmartPhoneFormat) {
            /** @type {?} */
            const smart_phone = /^09\d{8}\b/;
            hasMatch = smart_phone.test(val);
            if (hasMatch) {
                return true;
            }
        }
        return false;
    }
}
PhoneDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmPhone]',
                providers: [{ provide: NG_VALIDATORS, useExisting: PhoneDirective, multi: true }]
            },] }
];
/** @nocollapse */
PhoneDirective.ctorParameters = () => [];
PhoneDirective.propDecorators = {
    allowDashFormat: [{ type: Input }],
    allowSimpleFormat: [{ type: Input }],
    allowParenthesesFormat: [{ type: Input }],
    allowSmartPhoneFormat: [{ type: Input }],
    onlySmartPhoneFormat: [{ type: Input }],
    onlyCityPhoneFormat: [{ type: Input }]
};
if (false) {
    /**
     * @type {?}
     * @protected
     */
    PhoneDirective.prototype._tagName;
    /**
     * @type {?}
     * @protected
     */
    PhoneDirective.prototype._allowDashFormat;
    /**
     * 允許市話區碼用減號分隔
     * @type {?}
     */
    PhoneDirective.prototype.allowDashFormat;
    /**
     * @type {?}
     * @protected
     */
    PhoneDirective.prototype._allowSimpleFormat;
    /**
     * 允許市話區碼與號碼連續
     * @type {?}
     */
    PhoneDirective.prototype.allowSimpleFormat;
    /**
     * @type {?}
     * @protected
     */
    PhoneDirective.prototype._allowParenthesesFormat;
    /**
     * 允許市話區碼用小括號分隔
     * @type {?}
     */
    PhoneDirective.prototype.allowParenthesesFormat;
    /**
     * @type {?}
     * @protected
     */
    PhoneDirective.prototype._allowSmartPhoneFormat;
    /**
     * 允許手機號碼格式
     * @type {?}
     */
    PhoneDirective.prototype.allowSmartPhoneFormat;
    /**
     * @type {?}
     * @protected
     */
    PhoneDirective.prototype._onlySmartPhoneFormat;
    /**
     * @type {?}
     * @protected
     */
    PhoneDirective.prototype._onlyCityPhoneFormat;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/validation/validate-equal.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ValidateEqualDirective {
    constructor() { }
    /**
     * @return {?}
     */
    get isReverse() {
        if (!this.reverse) {
            return false;
        }
        return this.reverse === 'true';
    }
    /**
     * @param {?} c
     * @return {?}
     */
    validate(c) {
        /** @type {?} */
        const v = c.value;
        // control value
        /** @type {?} */
        const e = c.root.get(this.tmValidateEqual);
        if (this.isReverse) {
            if (e && v === e.value) {
                if (e.errors) {
                    delete e.errors['tmValidateEqual'];
                    if (!Object.keys(e.errors).length) {
                        e.setErrors(null);
                    }
                }
            }
            else {
                if (e) {
                    e.setErrors({ tmValidateEqual: false });
                }
            }
        }
        else {
            if (e && v !== e.value) {
                return { tmValidateEqual: false };
            }
        }
        return null;
    }
}
ValidateEqualDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmValidateEqual][ngModel]',
                providers: [
                    {
                        provide: NG_VALIDATORS,
                        useExisting: forwardRef((/**
                         * @return {?}
                         */
                        () => ValidateEqualDirective)),
                        multi: true
                    }
                ]
            },] }
];
/** @nocollapse */
ValidateEqualDirective.ctorParameters = () => [];
ValidateEqualDirective.propDecorators = {
    tmValidateEqual: [{ type: Input }],
    reverse: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    ValidateEqualDirective.prototype.tmValidateEqual;
    /** @type {?} */
    ValidateEqualDirective.prototype.reverse;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/validation/gcb-password.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: gcbPassword
 * 文化部資安規定密碼長度需要大於等於12個字，並包含下列4種字元中的3種：
 *  (1) 英文大寫字元 (A到Z)
 *  (2) 英文小寫字元 (a到z)
 *  (3) 數字 (0到9)
 *  (4) 特殊符號 (例如：!、$、#、%)
 */
class GcbPasswordDirective extends DefaultValidatorAbs {
    constructor() {
        super();
        this._tagName = 'tmGcbPassword';
    }
    /**
     * @param {?} val
     * @return {?}
     */
    valid(val) {
        /** @type {?} */
        const rule1 = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{12,}$/;
        /** @type {?} */
        const rule2 = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^\w\s]).{12,}$/;
        /** @type {?} */
        const rule3 = /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[^\w\s]).{12,}$/;
        /** @type {?} */
        const rule4 = /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{12,}$/;
        return rule1.test(val) || rule2.test(val) || rule3.test(val) || rule4.test(val);
    }
}
GcbPasswordDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmGcbPassword]',
                providers: [{ provide: NG_VALIDATORS, useExisting: GcbPasswordDirective, multi: true }]
            },] }
];
/** @nocollapse */
GcbPasswordDirective.ctorParameters = () => [];
if (false) {
    /**
     * @type {?}
     * @protected
     */
    GcbPasswordDirective.prototype._tagName;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/validation/requireSome.validator.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * 原名: multicks
 * 至少存在一個值，用在多值選項上
 */
class RequireSomeDirective extends DefaultValidatorAbs {
    constructor() {
        super();
        this._tagName = 'tmRequireSome';
        this.minLen = 1;
        this.maxLen = 1;
    }
    /**
     * @param {?} control
     * @return {?}
     */
    validate(control) {
        /** @type {?} */
        let val = control.value;
        if (this.multiValue) {
            val = this.multiValue;
        }
        else if (isNullOrUndefined(val) || val === '') {
            return Validators.nullValidator;
        }
        /** @type {?} */
        let ret = this.valid(val) ? null : { [this.tagName]: { name: val } };
        if (ret) {
            return ret;
        }
        ret = this.validMaxLen(val) ? null : { 'tmRequireSomeMaxLen': { name: val } };
        return ret;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    valid(val) {
        if (val && val.length >= this.minLen) {
            return true;
        }
        return false;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    validMaxLen(val) {
        if (val && val.length > this.maxLen) {
            return false;
        }
        return true;
    }
}
RequireSomeDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmRequireSome]',
                providers: [{ provide: NG_VALIDATORS, useExisting: RequireSomeDirective, multi: true }]
            },] }
];
/** @nocollapse */
RequireSomeDirective.ctorParameters = () => [];
RequireSomeDirective.propDecorators = {
    multiValue: [{ type: Input, args: ['tmRequireSome',] }],
    minLen: [{ type: Input }],
    maxLen: [{ type: Input }]
};
if (false) {
    /**
     * @type {?}
     * @protected
     */
    RequireSomeDirective.prototype._tagName;
    /** @type {?} */
    RequireSomeDirective.prototype.multiValue;
    /** @type {?} */
    RequireSomeDirective.prototype.minLen;
    /** @type {?} */
    RequireSomeDirective.prototype.maxLen;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/validation/email.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EmailDirective extends DefaultValidatorAbs {
    constructor() {
        super();
        this._tagName = 'email';
    }
    /**
     * @param {?} val
     * @return {?}
     */
    valid(val) {
        return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(val);
    }
}
EmailDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmEmail]',
                providers: [{ provide: NG_VALIDATORS, useExisting: EmailDirective, multi: true }]
            },] }
];
/** @nocollapse */
EmailDirective.ctorParameters = () => [];
if (false) {
    /**
     * @type {?}
     * @protected
     */
    EmailDirective.prototype._tagName;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/directive/validation/range.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RangeDirective extends DefaultValidatorAbs {
    constructor() {
        super();
        this._tagName = 'tmRange';
    }
    /**
     * @param {?} val
     * @return {?}
     */
    valid(val) {
        if (!isNullOrUndefined(this.min)) {
            if (this.min > val) {
                return false;
            }
        }
        if (!isNullOrUndefined(this.max)) {
            if (this.max < val) {
                return false;
            }
        }
        return true;
    }
}
RangeDirective.decorators = [
    { type: Directive, args: [{
                selector: '[tmRange]',
                providers: [{ provide: NG_VALIDATORS, useExisting: RangeDirective, multi: true }]
            },] }
];
/** @nocollapse */
RangeDirective.ctorParameters = () => [];
RangeDirective.propDecorators = {
    min: [{ type: Input }],
    max: [{ type: Input }]
};
if (false) {
    /**
     * @type {?}
     * @protected
     */
    RangeDirective.prototype._tagName;
    /**
     * 數值最小值
     * @type {?}
     */
    RangeDirective.prototype.min;
    /**
     * 數值最大值
     * @type {?}
     */
    RangeDirective.prototype.max;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/validate.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ValidateModule {
}
ValidateModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    ValidationErrorComponent,
                    AutoValidateFormDirective,
                    AutoValidateDirective,
                    TaiwanIdDirective,
                    PhoneDirective,
                    ValidateEqualDirective,
                    GcbPasswordDirective,
                    RequireSomeDirective,
                    EmailDirective,
                    RangeDirective,
                ],
                imports: [
                    CommonModule,
                    NgxPageScrollCoreModule
                ],
                exports: [
                    ValidationErrorComponent,
                    AutoValidateFormDirective,
                    AutoValidateDirective,
                    TaiwanIdDirective,
                    PhoneDirective,
                    ValidateEqualDirective,
                    GcbPasswordDirective,
                    RequireSomeDirective,
                    EmailDirective,
                    RangeDirective,
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: techmore-validate.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AutoValidateDirective, AutoValidateFormDirective, DefaultValidatorAbs, EmailDirective, GcbPasswordDirective, PhoneDirective, RangeDirective, RequireSomeDirective, TaiwanIdDirective, ValidateEqualDirective, ValidateModule, ValidationErrorMessage, ValidationErrorComponent as ɵa, AutoValidateService as ɵb };
//# sourceMappingURL=techmore-validate.js.map
